import { createApp } from 'vue'
import rollbarBridge from '../plugins/rollbarBridge'

class VueAppManager {
  constructor() {
    this.managedApps = new Map()
    this.boundCleanup = this.CleanupManagedApps.bind(this)
    this.lifecycleBound = false
    this.bindTurboLifecycle()
  }

  bindTurboLifecycle() {
    if (this.lifecycleBound) return

    document.addEventListener('turbo:visit', this.boundCleanup)
    document.addEventListener('turbo:before-cache', this.boundCleanup)
    this.lifecycleBound = true
  }

  CreateManagedApp({
    key,
    component,
    mountTarget,
    props = {},
    configureApp,
  }) {
    if (!component || !mountTarget) return null

    const mountElement = typeof mountTarget === 'string'
      ? document.querySelector(mountTarget)
      : mountTarget

    if (!mountElement) return null

    const appKey = key || mountElement.id || `vue-app-${this.managedApps.size + 1}`

    if (this.managedApps.has(appKey)) {
      this.unmountApp(this.managedApps.get(appKey))
      this.managedApps.delete(appKey)
    }

    if (mountElement.__vue_app__) {
      try {
        mountElement.__vue_app__.unmount()
      } catch (_e) {
        // Ignore if Vue already detached this app instance
      }
    }

    const app = createApp(component, props)
    this.applyDefaultGlobals(app)

    if (typeof configureApp === 'function') {
      configureApp(app)
    }

    app.mount(mountElement)
    this.managedApps.set(appKey, app)

    return app
  }

  applyDefaultGlobals(app) {
    app.use(rollbarBridge)
  }

  CleanupManagedApps(keys = null) {
    if (!keys) {
      this.managedApps.forEach(app => this.unmountApp(app))
      this.managedApps.clear()
      return
    }

    const keyList = Array.isArray(keys) ? keys : [keys]
    keyList.forEach(key => {
      if (!this.managedApps.has(key)) return
      this.unmountApp(this.managedApps.get(key))
      this.managedApps.delete(key)
    })
  }

  unmountApp(app) {
    if (!app) return

    try {
      app.unmount()
    } catch (_e) {
      // Ignore apps that were already unmounted
    }
  }
}

export default new VueAppManager()
